module.exports = __webpack_public_path__ + "img/ff_1.385c9bb1.png";